import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Typography, List, ListItem } from "@mui/material";
import CardTouch from "../../../UI/Card/CardTouch/CardTouch";
import shoppingCart from "../../../../assets/images/afinandinho_cart_start.svg";
import SystemContext from "../../../../context/SystemContext";
import { useContext,useEffect } from "react";
const SelectRenewOrAdd = ({ PlanItems, session }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {changePropertyUrl} = useContext(SystemContext);

  useEffect(() => {
    changePropertyUrl("/comprar/turbinar");
  },[])
  const handleBuyAdd = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChooseAdd",
        step: "SelectAddType",
      },
    });
  };

  const filteredPlans = session?.plans.active_base_plan?.filter(
    (plan) => plan.category === "BASE"
  );

  const handleRenewPlan = () => {
    changePropertyUrl("/comprar/turbinar/renovar",{metodoPagamento:filteredPlans[0].payment_method})

    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChooseAdd",
        step:
          filteredPlans[0].payment_method === "creditcard"
            ? "RenewPlanCreditCard"
            : "RenewPlanPix",
      },
    });
  };

  return (
    <Box sx={{
      display: "flex", flexDirection: "column", alignItems: "center", padding: 2, mt: { md: "80px" }
    }}>
      <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold", textAlign: "center", marginBottom: 1, color: "#662D91" }}>
        {t("purchase.what_do_you_want_to_do")}
      </Typography>
      <Typography sx={{ fontSize: "1rem", textAlign: "center", marginBottom: 3, color: "text.secondary" }}>
        {t("purchase.select_options")}
      </Typography>

      <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 3, md: 2 },
        alignItems: "stretch",
        width: "100%",
        justifyContent: "center",
        marginBottom: 3,
        maxWidth: { md: "800px" }
      }}>
        <CardTouch
          onClick={handleRenewPlan}
          sx={{
            width: { xs: "100%", md: "50%" },
            maxWidth: { xs: "350px", md: "none" },
            minHeight: { md: "120px" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box sx={{ padding: { xs: 3, md: 4 } }}>
            <Box sx={{ fontSize: "1.2rem", fontWeight: "bold", marginBottom: 1, textAlign: "center", color: "#662D91" }}>
              {t("purchase.renew_subscription")}
            </Box>
            <Box sx={{ fontSize: "0.9rem", opacity: 0.9, textAlign: "center" }}>
              {t("purchase.verify_renew_plan")}
            </Box>
          </Box>
        </CardTouch>

        <CardTouch
          onClick={handleBuyAdd}
          sx={{
            width: { xs: "100%", md: "50%" },
            maxWidth: { xs: "350px", md: "none" },
            minHeight: { md: "120px" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <Box sx={{ padding: { xs: 3, md: 4 } }}>
            <Box data-testid="buyAdd_bootsSubscription_text" sx={{ fontSize: "1.2rem", fontWeight: "bold", marginBottom: 1, textAlign: "center", color: "#662D91" }}>
              {t("purchase.boots_subscription")}
            </Box>
            <Box sx={{ fontSize: "0.9rem", opacity: 0.9, textAlign: "center" }}>
              {t("purchase.purchase_add")}
            </Box>
          </Box>
        </CardTouch>
      </Box>

      {PlanItems && (
        <List sx={{ width: "100%", maxWidth: 400, marginBottom: 3 }}>
          {PlanItems.map((item, i) => (
            <ListItem key={i} sx={{ fontSize: "0.8rem" }}>• {item}</ListItem>
          ))}
        </List>
      )}

      <Box component="img" src={shoppingCart} alt="" sx={{ maxWidth: "200px", height: "auto" }} />
    </Box>
  );
};

export default SelectRenewOrAdd;